
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"menu"}},[_c('rect',{attrs:{"x":"2","y":"2","width":"20","height":"3","rx":"2","ry":"2"}}),_c('rect',{attrs:{"x":"2","y":"11","width":"20","height":"3","rx":"2","ry":"2"}}),_c('rect',{attrs:{"x":"2","y":"20","width":"20","height":"3","rx":"2","ry":"2"}})])])])
          )
        }
      }
    